export default __webpack_public_path__ + "static/media/Hubano-1.349fadf5.png";